
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon24CellularGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  textRendering: "geometricPrecision",
  viewBox: "0 0 24 24"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAHlBMVEVMaXHGxsbHx8fHx8fIyMjHx8fHx8fHx8fOzs7GxsaII59UAAAACXRSTlMAyrEpimvg1R6GcNQcAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAVElEQVR42u2SQQ6AMAgEqQp0//9hJSYLNa3xAc6BkAyBAysSqIO4ClFgI0AaQ8+pDmOPdpUWe+5mFBp7dCLIL16F7wUv4kEKOwr24cbytcswzOJzAqMNBEtVXwyFAAAAAElFTkSuQmCC",
  width: 24,
  height: 24,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAHlBMVEVMaXHGxsbHx8fHx8fIyMjHx8fHx8fHx8fOzs7GxsaII59UAAAACXRSTlMAyrEpimvg1R6GcNQcAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAVElEQVR42u2SQQ6AMAgEqQp0//9hJSYLNa3xAc6BkAyBAysSqIO4ClFgI0AaQ8+pDmOPdpUWe+5mFBp7dCLIL16F7wUv4kEKOwr24cbytcswzOJzAqMNBEtVXwyFAAAAAElFTkSuQmCC",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 24 24\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAHlBMVEVMaXHGxsbHx8fHx8fIyMjHx8fHx8fHx8fOzs7GxsaII59UAAAACXRSTlMAyrEpimvg1R6GcNQcAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAVElEQVR42u2SQQ6AMAgEqQp0//9hJSYLNa3xAc6BkAyBAysSqIO4ClFgI0AaQ8+pDmOPdpUWe+5mFBp7dCLIL16F7wUv4kEKOwr24cbytcswzOJzAqMNBEtVXwyFAAAAAElFTkSuQmCC\" width=\"24\" height=\"24\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAHlBMVEVMaXHGxsbHx8fHx8fIyMjHx8fHx8fHx8fOzs7GxsaII59UAAAACXRSTlMAyrEpimvg1R6GcNQcAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAVElEQVR42u2SQQ6AMAgEqQp0//9hJSYLNa3xAc6BkAyBAysSqIO4ClFgI0AaQ8+pDmOPdpUWe+5mFBp7dCLIL16F7wUv4kEKOwr24cbytcswzOJzAqMNBEtVXwyFAAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-24-cellular-grey.9287c555d5519ef83f6ae4b24c2316a0.svg"),
        {
          React: SvgIcon24CellularGrey,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      